export const NEWSGRADE = [
    {id: 1, label: '一级', value: 'ONE'},
    {id: 2, label: '二级', value: 'TWO'}
]
export const LABELTYPE = [
    {id: 1, label: '产品标签', value: 'PRODUCT_LABEL'},
    {id: 2, label: '人物标签', value: 'PEOPLE_LABEL'},
    {id: 3, label: '机构标签', value: 'ORGANIZATION_LABEL'},
    {id: 4, label: '项目标签', value: 'PROJECT_LABEL'},
    {id: 5, label: '类别标签', value: 'CATEGORY_LABEL'},
    {id: 6, label: '自定义标签', value: 'CUSTOM_LABEL'},
]

